import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { MoneyState } from "../models/MoneyState";

const setMessageVisiable = (state: MoneyState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;